// src/components/ui/Icons.tsx
import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as SiIcons from 'react-icons/si';

// Creamos funciones simples que renderizan los iconos directamente
export const BitcoinIcon = ({ size = 24, color = "#003DA5", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaBitcoin size={size} color={color} />
  </span>
);

export const EthereumIcon = ({ size = 24, color = "#003DA5", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaEthereum size={size} color={color} />
  </span>
);

export const TetherIcon = ({ size = 24, color = "#26A17B", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <SiIcons.SiTether size={size} color={color} />
  </span>
);

export const TronIcon = ({ size = 24, color = "#FF060A", style = {} }) => (
  <span style={style}>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 64 64" 
      width={size} 
      height={size}
    >
      <path 
        d="M61.55,19.28c-3-2.77-7.15-7-10.53-10l-.2-.14a3.82,3.82,0,0,0-1.11-.62l0,0C41.56,7,3.63-.09,2.89,0a1.4,1.4,0,0,0-.58.22L2.12.37a2.23,2.23,0,0,0-.52.84l-.05.13v.71l0,.11C5.82,14.05,22.68,53,26,62.14c.2.62.58,1.8,1.29,1.86h.16c.38,0,2-2.14,2-2.14S58.41,26.74,61.34,23a9.46,9.46,0,0,0,1-1.48A2.41,2.41,0,0,0,61.55,19.28ZM36.88,23.37,49.24,13.12l7.25,6.68Zm-4.8-.67L10.8,5.26l34.43,6.35ZM34,27.27l21.78-3.51-24.9,30ZM7.91,7,30.3,26,27.06,53.78Z"
        fill={color}
      />
    </svg>
  </span>
);

export const SolanaIcon = ({size = 24, color = "#718ecf", style = {}}) =>(
  <span style={style}>
      {/* @ts-ignore */}
    <SiIcons.SiSolana size={size} color={color} />
  </span>
)

export const BinanceIcon = ({ size = 24, color = "#F3BA2F", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <SiIcons.SiBinance size={size} color={color} />
  </span>
);

export const QrCodeIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaQrcode size={size} color={color} />
  </span>
);

export const EyeIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaEye size={size} color={color} />
  </span>
);

export const EyeSlashIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaEyeSlash size={size} color={color} />
  </span>
);

export const ExchangeIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaExchangeAlt size={size} color={color} />
  </span>
);

export const HistoryIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaHistory size={size} color={color} />
  </span>
);

export const ArrowLeftIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaArrowLeft size={size} color={color} />
  </span>
);

export const CopyIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaCopy size={size} color={color} />
  </span>
);

export const ArrowUpIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaArrowUp size={size} color={color} />
  </span>
);

export const ArrowDownIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaArrowDown size={size} color={color} />
  </span>
);

export const SearchIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaSearch size={size} color={color} />
  </span>
);

export const ExternalLinkIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaExternalLinkAlt size={size} color={color} />
  </span>
);

export const RefreshCwIcon = ({ size = 24, color = "#000", style = {} }) => (
  <span style={style}>
    {/* @ts-ignore */}
    <FaIcons.FaSync size={size} color={color} />
  </span>
);